import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export const numbersOnly: ValidatorFn = (control: UntypedFormGroup): {[key: string]: any} | null => {
  const hasNumber = new RegExp(/^\d+$/);

  if (control.value !== null && control.value.length && !hasNumber.test(control.value)) {
    return { numbersOnly: true };
  }
  return null;
};
